// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"src-screens-Appointments-components-Checkbox-Checkbox-module__checkbox--GN5WE"};